import script from "./web-app-sign-up.vue?vue&type=script&setup=true&lang=js"
export * from "./web-app-sign-up.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__